import { PaymentMethod } from "enums";

export const accountabilityPaymentMethods = [
  PaymentMethod.Misfill,
  PaymentMethod.Misload,
  PaymentMethod.DriveOff,
];

export const isAccountabilityEnabled = false;

export const isAccountabilityPaymentMethod = (method) =>
  accountabilityPaymentMethods.includes(method);
